module.exports = __webpack_public_path__ + "static/media/procedureNewKtm.be0ecf03.svg";